import React from "react";

const LEGEND_ITEMS = [
  {
    label: "Working day",
    style: { background: "#ffffff", borderColor: "#e5e7eb" },
  },
  {
    label: "Weekly off",
    style: { background: "#cbdef1", borderColor: "#e5e7eb" },
  },
  {
    label: "Public holiday",
    style: { background: "#ecc494", borderColor: "#fed7aa" },
  },
  {
    label: "Leave",
    style: { background: "#d8a9c7", borderColor: "#fecaca" },
  },
  {
    label: "Half day",
    style: {
      background: "linear-gradient(135deg, #ffffff 50%, #f3f4f6 50%)",
      borderColor: "#e5e7eb",
    },
  },
  {
    label: "Has tasks",
    style: { background: "#4f46e5", borderColor: "#4f46e5" },
  },
];

export default function PlannerLegend() {
  return (
    <div className="planner-legend">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.label} className="legend-item">
          <span className="legend-swatch" style={item.style} /> {item.label}
        </span>
      ))}
      <span className="legend-hint">
        Right-click any day to manage | Double-click to drill down
      </span>
    </div>
  );
}